import React from "react";
import useSupabaseBrowser from "../hooks/use-supabase-browser";
import { useAuth } from "../providers/auth";
import { Link } from "react-router-dom";
import { useTitle } from "../providers/title";
import Search from "./Search";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
library.add(faBars);

export default () => {
  const { session } = useAuth();
  const supabase = useSupabaseBrowser();
  const { title } = useTitle();

  return (
    <header className="col-span-12 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between lg:gap-4">
      <div className="flex items-center justify-between w-full lg:w-auto">
        <h1 className="text-xl font-medium lg:text-2xl lg:font-light">
          {title}
        </h1>
        <label
          htmlFor="my-drawer"
          className="btn  btn-sm drawer-button lg:hidden ml-auto"
        >
          <FontAwesomeIcon size="2x" icon={["fas", "bars"]} />
        </label>
      </div>

      <div className="flex w-full items-center justify-between lg:justify-end gap-2 lg:gap-4">
        <Search />
        <div className="dropdown-end dropdown z-10">
          <div tabIndex={0} className="avatar btn btn-circle btn-ghost">
            <div className="w-10 rounded-full">
              <img src="https://picsum.photos/80/80?5" alt="User Avatar" />
            </div>
          </div>
          <ul
            tabIndex={0}
            className="menu dropdown-content mt-3 w-52 rounded-box bg-base-100 p-2 shadow-2xl"
          >
            <li>
              <div className="font-bold">{session?.user?.email}</div>
            </li>
            <li>
              <Link to="/profile">Profile</Link>
            </li>
            <li>
              <Link to="/settings">Settings</Link>
            </li>
            <li>
              <a onClick={() => supabase.auth.signOut()}>Logout</a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};
